<template>
  <div class="to-do-list">
    <p class="title">
      {{ $t(listTitle) }} {{ listItemNum }}
    </p>
    <div class="list">
      <p
        v-if="listItemNum === 0"
        class="lack-text"
      >
        {{ $t(lackText) }}
      </p>
      <slot />
    </div>
    <div class="to-do-list_button">
      <slot name="button" />
    </div>
  </div>
</template>
<script>
export default {
  name: "ToDoList",
  props: {
    listItemNum: {
      type: Number,
      default: 0,
    },
    listTitle: {
      type: String,
    },
    toDoList: {
      type: Array,
      default() {
        return [];
      },
    },
    lackText: {
      type: String,
    },
  },
  methods: {},
};
</script>
<style lang="scss">
@import "@/assets/scss/component/to-do-list";
</style>